import CoordMapType from '../../map/coordMapType'
import MapAdapter from './mapAdapter'
import MapController from './mapController'
import { LatLon } from './gpsfunctions'

var drawCircleEnabled = false
var drawGPSAidsEnabled = false
var stopRange = 20
var latestStops = new Array()
var locationMarker
var lastRealLocation = null
var activeStop
var currentTrail = null
var college = null
var stopIdPlaying = ''
var selectedStop = null
var accuracyCircle = null
var stopShadowIcon
var stopIcon
var startTrailIcon
var endTrailIcon
var activeStopShadowIcon
var activeStopIcon
var preventClickPropogation = false
var gpsIcon
var currentHoverStopId = -1
var tooltipOverlay
var markersVisible = null

var userkey = null
var sessionId = null
var player = null
var hoverColor = null
var mapMarkers = new Array()
var minCoords = null
var maxCoords = null
var currentDirections = null
var hasPolygons = false

var chicago = null
var coordinateMapType = null

var mapCenter = null
var mapZoom = null

export function initGoogleMaps() {
    if (typeof google == 'undefined') {
        console.log('Google Maps Undefined. Maps disabled.')
    } else if (!chicago || !coordinateMapType) {
        chicago = new google.maps.LatLng(41.850033, -87.6500523)
        coordinateMapType = new CoordMapType()
    }
}

export function clearDirections() {
    if (currentDirections) {
        currentDirections.polyline.setMap(null)
        currentDirections.startMarker.setMap(null)
        currentDirections.endMarker.setMap(null)
    }
}

export function showDirections(points, hasGoogleMap) {
    var i,
        markers,
        polyline,
        path = [],
        customPoint
    hasGoogleMap = hasGoogleMap || false

    clearDirections()
    if (!points.length) {
        return
    }
    currentDirections = {}

    for (i = 0; i < points.length; i++) {
        if (hasGoogleMap) {
            //for native Google Maps is does not need to convert points.
            path.push(new google.maps.LatLng(points[i].lat(), points[i].lng()))
        } else {
            markers = findShortestDistances(new YCLatLng(points[i].lat(), points[i].lng()))
            customPoint = find3CirclesCenter(markers, 1)
            path.push(new google.maps.LatLng(customPoint.y, customPoint.x))
        }
    }
    polyline = new google.maps.Polyline({
        path: path,
        strokeColor: '#FF0000',
        strokeOpacity: 0.7,
        strokeWeight: 7,
    })

    currentDirections.polyline = polyline
    polyline.setMap(MapAdapter.map)

    currentDirections.startMarker = new google.maps.Marker({
        position: path[0],
        icon: startTrailIcon,
    })
    currentDirections.startMarker.setMap(MapAdapter.map)

    currentDirections.endMarker = new google.maps.Marker({
        position: path[path.length - 1],
        icon: endTrailIcon,
    })
    currentDirections.endMarker.setMap(MapAdapter.map)

    MapAdapter.map.panTo(path[0])
}

export function initDirectionsConfiguration(loc) {
    minCoords = loc.minCoords
    maxCoords = loc.maxCoords
    mapMarkers = loc.mapMarkers
}

export function calculateDirections(start, end, callback, errorCallback) {
    function isInBounds(pt) {
        return (
            pt.lat() < minCoords.lat() &&
            pt.lng() > minCoords.lng() &&
            pt.lat() > maxCoords.lat() &&
            pt.lng() < maxCoords.lng()
        )
    }

    if (!isInBounds(start)) {
        errorCallback('Start point is outside location bounds.')
        return
    }

    if (!isInBounds(end)) {
        errorCallback('Destination point is outside location bounds.')
        return
    }

    var directionsService = new google.maps.DirectionsService()

    directionsService.route(
        {
            origin: start,
            destination: end,
            travelMode: google.maps.TravelMode.WALKING,
        },
        function(res, status) {
            var path = []

            if (status !== 'OK') {
                errorCallback('Path not found.')
                return
            }

            // sanity checks and create path
            if (res.routes && res.routes.length) {
                var legs = res.routes[0].legs
                for (var e = 0, ee = legs.length; e < ee; ++e) {
                    var steps = legs[e].steps

                    if (steps.length) {
                        path.push(steps[0].start_location)

                        for (var s = 0, ss = steps.length; s < ss; ++s) {
                            path.push(steps[s].end_location)
                        }
                    }
                }
            }

            // success - return path
            callback(path)
        }
    )
}

export function updateLocation(point, recenter, accuracy) {
    var multiplyer = 1
    var markers = findShortestDistances(point)
    var centerPoint = point
    if (markers.length > 0) {
        var centerPoint = find3CirclesCenter(markers, multiplyer)
    }
    if (centerPoint) {
        if (accuracyCircle != null) {
            accuracyCircle.setMap(null)
            accuracyCircle = null
        }
        var centerLatLng = new google.maps.LatLng(centerPoint.y, centerPoint.x)
        if (locationMarker) {
            locationMarker.setMap(null)
        }
        locationMarker = new google.maps.Marker({ position: centerLatLng, icon: gpsIcon })
        locationMarker.setMap(MapAdapter.map)
        if (accuracy && accuracy > 20) {
            accuracyCircle = MapController.drawCircle(
                MapAdapter.map,
                centerLatLng,
                accuracy * multiplyer,
                40,
                '#0b64b3',
                true
            )
        }
        if (recenter) {
            MapAdapter.map.panTo(centerLatLng)
        }
    } else {
        //alert("Could not locate point");
    }
}

export function selectClosestStop(point) {
    var i = 0
    var shortestD = 100000000
    var shortestWP = null
    for (i = 0; i < MapController.getStops().length; i++) {
        var wpLoc = new Point(MapController.getStops()[i].reallng, MapController.getStops()[i].reallat)
        var d = distance(wpLoc, point)
        if (d < stopRange + MapController.getStops()[i].radius && d < shortestD) {
            shortestD = d
            shortestWP = MapController.getStops()[i]
        }
    }
    if (shortestD == 100000000) {
        return null
    }
    var MIN_HITS = 1

    // NO need to updated markers because it is already selected
    if (latestStops.length > MIN_HITS && shortestWP == latestStops[0]) {
        return null
    }

    if (latestStops.length > 0 && shortestWP != latestStops[0]) {
        latestStops = new Array()
    }
    if (latestStops.length == 0) {
        MapController.stopEnteredEvent(shortestWP)
    }
    latestStops.push(shortestWP)
    if (latestStops.length > MIN_HITS) {
        MapController.stopChangedEvent(activeStop, shortestWP)
        if (activeStop) {
            activeStop.marker.setMap(null)
            var normalMarker = new google.maps.Marker({
                position: new google.maps.LatLng(activeStop.customlat, activeStop.customlng),
                icon: stopIcon,
            })
            normalMarker.setMap(MapAdapter.map)
            activeStop.marker = normalMarker
            google.maps.event.addListener(
                normalMarker,
                'click',
                new Function(
                    "moveToLocation('" + activeStop.id + "'," + activeStop.startLat + ',' + activeStop.startLng + ')'
                )
            )
        }
        activeStop = shortestWP
        shortestWP.marker.setMap(null)
        var hotMarker = new google.maps.Marker({
            position: new google.maps.LatLng(shortestWP.customlat, shortestWP.customlng),
            icon: activeStopIcon,
        })
        hotMarker.setMap(MapAdapter.map)
        shortestWP.marker = hotMarker
        google.maps.event.addListener(
            hotMarker,
            'click',
            new Function(
                "moveToLocation('" + shortestWP.id + "'," + shortestWP.startLat + ',' + shortestWP.startLng + ')'
            )
        )
        return activeStop
    }
    return null
}

export function toolTipOverlap(p, tooltip) {
    var x = 0,
        y = 0
    if (MapAdapter.map.activeTooltip && tooltip) {
        var infoBox = $('.infoBox')
        var tX = p.x,
            tY = p.y,
            tWidth = tooltip.width(),
            tHeight = tooltip.height(),
            iX = infoBox.position().left,
            iY = infoBox.position().top,
            iWidth = infoBox.width(),
            iHeight = infoBox.height()

        if (tX + tWidth >= iX && tX <= iX + iWidth && tY + tHeight >= iY && tY <= iY + iHeight) {
            if (tX < iX + iWidth / 2) x = iX - tX - tWidth - 28
            else x = iX + iWidth - tX + 14

            if (tY < iY + iHeight / 2) y = iY - tY - tHeight - 28
            else y = iY + iHeight - tY + 14

            if (x != 0 && Math.abs(x) < Math.abs(y)) y = 0
            else x = 0
        }
    }
    return { x: x, y: y }
}

export function find3CirclesCenter(markers, multiplyer) {
    var c1 = markers[0].getCircle(multiplyer)
    var c2 = markers[1].getCircle(multiplyer)
    var c3 = markers[2].getCircle(multiplyer)

    var i12 = findIntersectionOfCircle(c1, c2)
    if (i12 == '') {
        return find3CirclesCenter(markers, multiplyer * 1.1)
    } else if (i12 instanceof Circle) {
        if (drawGPSAidsEnabled) {
            MapController.drawCircle(MapAdapter.map, c1.center, c1.radius, 40)
            MapController.drawCircle(MapAdapter.map, c2.center, c2.radius, 40)
        }
        return find2CirclesCenter(i12, c3, 1)
    }
    var i23 = findIntersectionOfCircle(c2, c3)
    if (i23 == '') {
        return find3CirclesCenter(markers, multiplyer * 1.1)
    } else if (i23 instanceof Circle) {
        if (drawGPSAidsEnabled) {
            MapController.drawCircle(MapAdapter.map, c2.center, c2.radius, 40)
            MapController.drawCircle(MapAdapter.map, c3.center, c3.radius, 40)
        }
        return find2CirclesCenter(i23, c1, 1)
    }
    var i13 = findIntersectionOfCircle(c1, c3)
    if (i13 == '') {
        return find3CirclesCenter(markers, multiplyer * 1.1)
    } else if (i13 instanceof Circle) {
        if (drawGPSAidsEnabled) {
            MapController.drawCircle(MapAdapter.map, c1.center, c1.radius, 40)
            MapController.drawCircle(MapAdapter.map, c3.center, c3.radius, 40)
        }
        return find2CirclesCenter(i13, c2, 1)
    }

    var intersectionPoints = new Array()

    if (i12 instanceof Point) {
        if (insideCircle(c3, i12)) {
            intersectionPoints.push(i12)
        } else {
            return find3CirclesCenter(markers, multiplyer * 1.1)
        }
    } else {
        var i1 = insideCircle(c3, i12[0])
        var i2 = insideCircle(c3, i12[1])
        if (!i1 && !i2) {
            return find3CirclesCenter(markers, multiplyer * 1.1)
        }
        if (i1) {
            intersectionPoints.push(i12[0])
        }
        if (i2) {
            intersectionPoints.push(i12[1])
        }
    }

    if (i23 instanceof Point) {
        if (insideCircle(c1, i23)) {
            intersectionPoints.push(i23)
        } else {
            return find3CirclesCenter(markers, multiplyer * 1.1)
        }
    } else {
        var i1 = insideCircle(c1, i23[0])
        var i2 = insideCircle(c1, i23[1])
        if (!i1 && !i2) {
            return find3CirclesCenter(markers, multiplyer * 1.1)
        }
        if (i1) {
            intersectionPoints.push(i23[0])
        }
        if (i2) {
            intersectionPoints.push(i23[1])
        }
    }

    if (i13 instanceof Point) {
        if (insideCircle(c2, i13)) {
            intersectionPoints.push(i13)
        } else {
            return find3CirclesCenter(markers, multiplyer * 1.1)
        }
    } else {
        var i1 = insideCircle(c2, i13[0])
        var i2 = insideCircle(c2, i13[1])
        if (!i1 && !i2) {
            return find3CirclesCenter(markers, multiplyer * 1.1)
        }
        if (i1) {
            intersectionPoints.push(i13[0])
        }
        if (i2) {
            intersectionPoints.push(i13[1])
        }
    }

    if (drawGPSAidsEnabled) {
        MapController.drawCircle(MapAdapter.map, c1.center, c1.radius, 40)
        MapController.drawCircle(MapAdapter.map, c2.center, c2.radius, 40)
        MapController.drawCircle(MapAdapter.map, c3.center, c3.radius, 40)
        var i
        for (i = 0; i < intersectionPoints.length; i++) {
            new google.maps.Marker({
                position: new google.maps.LatLng(intersectionPoints[i].y, intersectionPoints[i].x),
                map: MapAdapter.map,
            })
        }
    }
    if (intersectionPoints.length == 1) {
        return intersectionPoints[0]
    }
    if (intersectionPoints.length == 2) {
        return getCenterOfShape(new Array(intersectionPoints[0], intersectionPoints[1]))
    }
    if (intersectionPoints.length == 3) {
        return getCenterOfShape(new Array(intersectionPoints[0], intersectionPoints[1], intersectionPoints[2]))
    }
    if (intersectionPoints.length == 2) {
        return getCenterOfShape(
            new Array(intersectionPoints[0], intersectionPoints[1], intersectionPoints[2], intersectionPoints[3])
        )
    }
}

// Returns
export function find2CirclesCenter(c1, c2, multiplyer) {
    c1.radius = c1.radius * multiplyer
    c2.radius = c2.radius * multiplyer
    var i12 = findIntersectionOfCircle(c1, c2)
    if (i12 == '') {
        return find2CirclesCenter(c1, c2, 1.1)
    }
    if (drawGPSAidsEnabled) {
        MapController.drawCircle(MapAdapter.map, c2.center, c2.radius, 40)
    }
    if (i12 instanceof Circle) {
        return i12.center
    }
    if (i12 instanceof Point) {
        return i12
    }
    var smallCircle = c2
    var largeCircle = c1
    if (c1.radius < c2.radius) {
        smallCircle = c1
        largeCircle = c2
    }
    // We are trying to get the point on the perimeter of the smaller circle that also lies on
    // the line connecting the midpoint of the intersections and the center of the small circle.
    // The two intersection points and the newly calculated point will form a triangle. The center
    // of the triangle will be the center of the overall intersection.

    // Get the midpoint for the two intersection points
    var midpoint = getCenterOfShape(new Array(i12[0], i12[1]))
    // Get the angle of the line connecting the midpoint and the center of the small circle
    var angle = Math.atan((midpoint.y - smallCircle.center.y) / (midpoint.x - smallCircle.center.x))
    // Calculate the length for the line right across from the angle and parellel to Y-axis
    var r2d = 180 / Math.PI
    var d2r = Math.PI / 180
    var conversionlat = (smallCircle.radius / 6371000) * r2d //  using 6371000 as earth's radius
    var conversionlng = conversionlat / Math.cos(smallCircle.center.y * d2r)
    var p1 = new Point()
    p1.y = smallCircle.center.y + conversionlat * Math.sin(angle)
    p1.x = smallCircle.center.x + conversionlng * Math.cos(angle)

    var p2 = new Point()
    p2.y = smallCircle.center.y - conversionlat * Math.sin(angle)
    p2.x = smallCircle.center.x - conversionlng * Math.cos(angle)
    if (distance(p1, largeCircle.center) < largeCircle.radius) {
        return getCenterOfShape(new Array(i12[0], i12[1], p1))
    } else {
        return getCenterOfShape(new Array(i12[0], i12[1], p2))
    }
}

//Returns intersection points for two circles
export function findIntersectionOfCircle(c1, c2) {
    //Calculate distance between centres of circle
    var d = distance(c1.center, c2.center)
    var c1r = c1.radius
    var c2r = c2.radius
    var m = c1r + c2r
    var n = c1r - c2r

    if (n < 0) {
        n = n * -1
    }

    //No solns
    if (d > m) {
        return ''
    }

    //Circle are contained within each other
    if (d < n) {
        if (c1r < c2r) {
            return c1
        }
        return c2
    }

    //Circles are the same
    if (d == 0 && c1r == c2r) {
        return c1
    }

    var a = (c1r * c1r - c2r * c2r + d * d) / (2 * d)
    var h = Math.sqrt(c1r * c1r - a * a)

    //Calculate point p, where the line through the circle intersection points crosses the line between the circle centers.
    var p = new Point()
    p.x = c1.center.x + (a / d) * (c2.center.x - c1.center.x)
    p.y = c1.center.y + (a / d) * (c2.center.y - c1.center.y)

    var gps = new LatLon(c1.center.y, c1.center.x)
    var newP1 = gps.destPoint(LatLon.bearing(c1.center.y, c1.center.x, c2.center.y, c2.center.x), a / 1000)

    //1 soln , circles are touching
    if (d == c1r + c2r) {
        return newP1
    }
    //2solns
    var p1 = new Point()
    var p2 = new Point()
    gps = new LatLon(newP1.y, newP1.x)
    p1 = gps.destPoint(LatLon.bearing(c1.center.y, c1.center.x, newP1.y, newP1.x) + 90, h / 1000)
    p2 = gps.destPoint(LatLon.bearing(c1.center.y, c1.center.x, newP1.y, newP1.x) - 90, h / 1000)

    return new Array(p1, p2)
}

export function getCenterOfShape(vertices) {
    if (vertices.length == 2) {
        return LatLon.midPoint(vertices[0].y, vertices[0].x, vertices[1].y, vertices[1].x)
    }
    var i
    var sumx = 0
    var sumy = 0
    for (i = 0; i < vertices.length; i++) {
        sumx = sumx + vertices[i].x
        sumy = sumy + vertices[i].y
    }
    return new Point(sumx / i, sumy / i)
}

export function insideCircle(circle, point) {
    var d = distance(circle.center, point)
    return d <= circle.radius
}

export function findShortestDistances(point) {
    var markers = new Array()
    var longestIndex = -1
    var i = 0
    for (i = 0; i < mapMarkers.length; i++) {
        var d = distance(mapMarkers[i].realPoint, point)
        if (markers.length < 3) {
            markers.push(new DistanceMarker(mapMarkers[i].realPoint, mapMarkers[i].customPoint, d, i + 1))
            longestIndex = getLongestIndex(markers)
        } else if (d < markers[longestIndex].distance) {
            markers[longestIndex] = new DistanceMarker(mapMarkers[i].realPoint, mapMarkers[i].customPoint, d, i + 1)
            longestIndex = getLongestIndex(markers)
        }
    }
    return markers
}

export function getLongestIndex(list) {
    var i
    var biggestIndex = 0
    for (i = 1; i < list.length; i++) {
        if (list[i].distance > list[biggestIndex].distance) {
            biggestIndex = i
        }
    }
    return biggestIndex
}

export function moveToLocation(stopid, lat, lng) {
    moveToPoint(lat, lng)
    MapAdapter.selectStop(stopid, this.automaticAudioEnabled, false)
}

export function moveToPoint(lat, lng) {
    var p = new google.maps.LatLng(lat, lng)
    MapAdapter.map.panTo(p)
}

export class MapMarker {
    constructor(customLat, customLng, realLat, realLng) {
        this.realPoint = new YCLatLng(realLat, realLng)
        this.customPoint = new YCLatLng(customLat, customLng)
    }
}

export function DistanceMarker(realPoint, customPoint, distance, index) {
    this.realPoint = realPoint
    this.customPoint = customPoint
    this.distance = distance
    this.index = index
}

DistanceMarker.prototype.getCircle = function(multiplyer) {
    return new Circle(this.customPoint, this.distance * multiplyer)
}

export function Circle(center, radius) {
    this.center = center
    this.radius = radius
}

export function toRad(num) {
    return (Math.PI / 180) * num
}

export function distance(p1, p2) {
    //return Math.sqrt(Math.pow(p1.x - p2.x, 2) + Math.pow(p1.y - p2.y, 2));
    var R = 6371000 // meters
    var dLat = toRad(p2.y - p1.y)
    var dLon = toRad(p2.x - p1.x)
    var a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRad(p1.y)) * Math.cos(toRad(p2.y)) * Math.sin(dLon / 2) * Math.sin(dLon / 2)
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
    var d = R * c
    return d
}

export function Stop(dataObj) {
    this.id = dataObj.id
    this.college = dataObj.college
    this.title = dataObj.title
    this.customlat = dataObj.customlat
    this.customlng = dataObj.customlng
    this.reallat = dataObj.reallat
    this.reallng = dataObj.reallng
    this.radius = dataObj.radius
    this.marker
    this.audio = dataObj.audio
    if (this.audio == '') this.audio = undefined
    this.shape = dataObj.shape

    this.hasVideo = dataObj.hasVideo
    this.totalVideos = dataObj.totalVideos
    this.videoThumb = dataObj.videoThumb

    this.hasPanorama = dataObj.hasPanorama
    this.totalPanos = dataObj.totalPanos
    this.panoThumb = dataObj.panoThumb

    this.hasPicture = dataObj.hasPicture
    this.totalPhotos = dataObj.totalPhotos
    this.photoThumb = dataObj.photoThumb

    this.startLat = dataObj.startLat
    this.startLng = dataObj.startLng
    this.fullMapDescription = dataObj.fullMapDescription
    this.bounds = new google.maps.LatLngBounds()

    if (this.shape != null) {
        hasPolygons = true
        var i
        for (i = 0; i < this.shape.getPath().getLength(); i++) {
            this.bounds.extend(this.shape.getPath().getAt(i))
        }
        this.center = findPolyCenter(this.shape)
        if (this.customlat == 0 || this.customlng == 0) {
            this.customlat = this.center.lat()
            this.customlng = this.center.lng()
        }
    }
}
export function findPolyArea(shape) {
    var area = 0,
        length = shape.getPath().getLength(),
        i,
        j,
        point1,
        point2

    for (i = 0, j = length - 1; i < length; j = i, i++) {
        point1 = shape.getPath().getAt(i)
        point2 = shape.getPath().getAt(j)
        area += point1.lat() * point2.lng()
        area -= point1.lng() * point2.lat()
    }
    area /= 2
    return area
}
export function findPolyCenter(shape) {
    var x = 0,
        y = 0,
        length = shape.getPath().getLength(),
        i,
        j,
        f,
        point1,
        point2

    for (i = 0, j = length - 1; i < length; j = i, i++) {
        point1 = shape.getPath().getAt(i)
        point2 = shape.getPath().getAt(j)
        f = point1.lat() * point2.lng() - point2.lat() * point1.lng()
        x += (point1.lat() + point2.lat()) * f
        y += (point1.lng() + point2.lng()) * f
    }

    f = findPolyArea(shape) * 6

    return new google.maps.LatLng(x / f, y / f)
}

export function iTrail(id, name, points) {
    this.id = id
    this.name = name
    this.points = points
}

export function YCLatLng(lat, lng) {
    this.x = lng
    this.y = lat
}

YCLatLng.prototype.lat = function() {
    return this.y
}

YCLatLng.prototype.lng = function() {
    return this.x
}

export function Point(x, y) {
    this.x = x
    this.y = y
}

export function BubbleText(stop) {
    this.stop = stop
}
BubbleText.prototype.buildMediaPanel = function(mediaType, visible, count, image) {
    if (!visible) return ''
    var title = '',
        module = ''
    switch (mediaType) {
        case 'pano':
            title = "360's"
            module = 'panos'
            break
        case 'video':
            title = 'Videos'
            module = 'videos'
            break
        case 'photo':
            title = 'Photos'
            module = 'photos'
            break
        case 'audio':
            title = 'Audio'
            module = 'audio'
            break
    }

    var anchor = $('<a>').attr('title', title)
    var info = $('<span>').addClass('info')
    var text = $('<span>')
        .addClass('title')
        .html(title)
    var mediaCount = $('<span>')
        .addClass('count')
        .html(count)

    info.append(text).append(mediaCount)
    if (mediaType == 'audio') {
        anchor.addClass('audio-container')
        var audioProgress = $('<span>').addClass('audioProgress')
        anchor.append(audioProgress)
        var img = $('<div>').addClass('button-audio')
    } else {
        anchor.addClass('module-' + module + ' badge')
        anchor.attr('type', module)
        var img = $('<img>').attr('src', image)
    }
    anchor.append(img).append(info)
    return anchor[0].outerHTML
}
BubbleText.prototype.getDescription = function(description, truncate) {
    description = description || ''
    var container = $('<div>')
        .addClass('description')
        .addClass('scrolling')

    var content = $('<div>')
        .addClass('content')
        .addClass('fullText')
        .addClass('scrolling')
        .html(description)
    if (truncate) {
        if (description.length > 180) {
            description = description.substring(0, 180) + '...'
        } else {
            container.addClass('noexpand')
        }
        var shortText = $('<div>')
            .addClass('content')
            .addClass('shortText')
            .addClass('scrolling')
            .html(description)
        container.append(shortText)
    }

    container.append(content)
    return container[0].outerHTML
}
BubbleText.prototype.getExpand = function() {
    var container = $('<div>').addClass('desc-expand-container')
    var expand = $('<a>')
        .addClass('desc-expand')
        .attr('href', 'javascript:void(0)')
    container.append(expand)
    return container[0].outerHTML
}
BubbleText.prototype.setRightMenu = function() {
    $('.mobile-info').html(
        '<h1>' +
            this.stop.title +
            '</h1>' +
            this.buildMediaPanel('audio', this.stop.audio, '', '') +
            '<div class="modules">' +
            '<div class="bubbleMedia">' +
            this.buildMediaPanel('pano', this.stop.hasPanorama, this.stop.totalPanos, this.stop.panoThumb) +
            this.buildMediaPanel('video', this.stop.hasVideo, this.stop.totalVideos, this.stop.videoThumb) +
            this.buildMediaPanel('photo', this.stop.hasPicture, this.stop.totalPhotos, this.stop.photoThumb) +
            '</div>' +
            '</div>' +
            this.getDescription(this.stop.fullMapDescription, false)
    )
}
BubbleText.prototype.getMobileBody = function() {
    this.setRightMenu()
    var includeAudio = this.stop.audio != null
    var audioClass = includeAudio ? '' : 'noaudio'
    return (
        '<div class="mobileText ' +
        audioClass +
        '">' +
        this.buildMediaPanel('audio', includeAudio, '', '') +
        '<h1>' +
        this.stop.title +
        '</h1>' +
        '<div class="expandButton"></div>' +
        '</div>'
    )
}
BubbleText.prototype.getDesktopBody = function() {
    return (
        '<div class="bubbleText">' +
        '<h1>' +
        this.stop.title +
        '</h1>' +
        '<div class="modules">' +
        '<div class="bubbleMedia">' +
        this.buildMediaPanel('audio', this.stop.audio != null, '', '') +
        this.buildMediaPanel('pano', this.stop.hasPanorama, this.stop.totalPanos, this.stop.panoThumb) +
        this.buildMediaPanel('video', this.stop.hasVideo, this.stop.totalVideos, this.stop.videoThumb) +
        this.buildMediaPanel('photo', this.stop.hasPicture, this.stop.totalPhotos, this.stop.photoThumb) +
        '</div>' +
        '</div>' +
        this.getDescription(this.stop.fullMapDescription, true) +
        this.getExpand() +
        '<a class="button-close" href="javascript:void(0)"></a>' +
        '</div>'
    )
}
BubbleText.prototype.getBody = function() {
    return this.getDesktopBody() + this.getMobileBody()
}

export function switchExpandImage(wpId) {
    var on = document.getElementById('bbleexpand_' + wpId + '_on')
    var off = document.getElementById('bbleexpand_' + wpId)
    if (on.style.display == 'none') {
        on.style.display = ''
        off.style.display = 'none'
        setTimeout("switchExpandImage('" + wpId + "')", 800)
    } else {
        on.style.display = 'none'
        off.style.display = ''
    }
    return false
}

export function switchAudioImage(wpId) {
    var on = document.getElementById('bbleaudio_' + wpId + '_on')
    var off = document.getElementById('bbleaudio_' + wpId)
    if (on.style.display == 'none') {
        off.style.display = 'none'
        on.style.display = ''
        setTimeout("switchAudioImage('" + wpId + "')", 800)
    } else {
        on.style.display = 'none'
        off.style.display = ''
    }
    return false
}

/**
 * stop event from propogating. The default event.stopPropogation()
 * is not working on the iphone so the function provides a hack
 */
export function stopMapClickEventPropogation(e) {
    if (e.stopPropagation) {
        e.stopPropagation()
    }
    if (e.preventDefault) {
        e.preventDefault()
    }
    if (MapController.isMobilePhone()) {
        preventClickPropogation = true
    }
}
